// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'md', // default - only for display purposes
    },
})


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js